import { useState } from 'react';

const plans = [
  {
    id: '3-months',
    name: '3 Months Membership',
    price: 5999,
    features: [],
  },
  {
    id: 'annual',
    name: 'Annual Membership',
    price: 19999,
    features: [],
  },
];

interface Plan {
  id: string;
  name: string;
  price: number;
  features: string[];
}

const UpiPayment = ({ selectedPlan }: { selectedPlan: Plan }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900">UPI Payment</h3>
      <p className="mt-2 text-gray-600">Scan the QR code below to pay INR {selectedPlan.price} using UPI.</p>
      <img src="/path-to-your-qr-code.png" alt="UPI QR Code" className="mt-4 w-48 h-48" />
    </div>
  );
};

export default function Signup() {
  const [selectedPlan, setSelectedPlan] = useState(plans[0]);

  return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mx-auto px-4 py-8">
        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Unlock Your B2B Marketing Potential with Alfa Entrepreneur!</h2>
          <p className="text-gray-600">
              <p>Step into the ultimate membership platform, meticulously crafted for ambitious and 
              forward-thinking professionals who are determined to excel in the dynamic world of B2B 
              marketing. At Alfa Entrepreneur, you gain access to a vast treasure trove of online resources,
              including comprehensive guides, exclusive industry insights, actionable strategies, and 
              expert-curated content—all designed to fast-track your career and elevate your marketing 
              expertise to new heights.</p>
              <br />
              <p>But that’s just the beginning. Alfa Entrepreneur goes beyond static content by offering you 
              an engaging, vibrant private community of marketers, entrepreneurs, and business leaders. 
              Here, you can actively participate in discussions, ask critical questions, seek and offer 
              real-time feedback, share ideas, and collaborate on innovative strategies. It’s more than 
              a network—it’s a powerful ecosystem where ideas flourish and relationships turn into 
              opportunities.</p>
              <br />
              <p>Built by a seasoned Chief Marketing Officer (CMO) and a former Vice President of Marketing 
              with years of hands-on experience, Alfa Entrepreneur bridges the crucial gap left by traditional
               education, which often fails to address the real-world challenges of B2B marketing. In a world
              where continuous learning and connection are key, Alfa Entrepreneur stands as your trusted 
              companion and guide.</p>
              <br />
              <p>Are you ready to break barriers, scale your business, and establish yourself as a leader in 
              B2B marketing? The revolution in your marketing journey begins here. Join Alfa Entrepreneur 
              today—your pathway to B2B marketing mastery awaits.</p>
          </p>
        </div>
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Choose Your Membership Plan</h2>
            <div className="mb-8">
                    {plans.map((plan) => (
                <div key={plan.id} className="mb-4">
                    <input
                    type="radio"
                    id={plan.id}
                    name="plan"
                    value={plan.id}
                    checked={selectedPlan.id === plan.id}
                    onChange={() => setSelectedPlan(plan)}
                    className="mr-2"
                    />
                    <label htmlFor={plan.id} className="text-lg font-medium text-gray-700">
                        {plan.name} - INR {plan.price}
                     </label>
                </div>
                ))}
            </div>
                <div>
                    <UpiPayment selectedPlan={selectedPlan} />
                </div>
        </div>
    </div>
  );
}